<script>
import BoardCard from "@/components/BoardCard.vue";
import TgBotSettingsBlock from "@/components/block-admin/TgBotSettingsBlock.vue";
import LoggerStateBlock from "@/components/block-admin/LoggerStateBlock.vue";
import EmailServiceSettingsBlock from "@/components/block-admin/EmailServiceSettingsBlock.vue";

export default {
  name: 'AdminState',
  components: {EmailServiceSettingsBlock, BoardCard, TgBotSettingsBlock, ClickhouseBlock: LoggerStateBlock},
  data() {
    return {}
  }
}
</script>

<template>
  <div class="grid grid-cols-1 mx-5 my-5 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-3 gap-6">

    <BoardCard title="Tg bot">
      <TgBotSettingsBlock/>
    </BoardCard>

    <BoardCard title="Email service">
      <EmailServiceSettingsBlock/>
    </BoardCard>

    <BoardCard title="Clickhouse">
      <ClickhouseBlock/>
    </BoardCard>
  </div>
</template>

<style scoped>

</style>